<template>
  <div id="app">
    <span v-if="showNavigation">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <span v-if="signedIn">
        <!-- <router-link :to=profileUrl>Apps</router-link> | -->
        <router-link to="/setup">Set up</router-link>
      </span>
      <span v-else>
        <router-link to="/login">Log in</router-link>
      </span>
    </div>
    </span>
    <router-view/>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Home',
  data() {
    return {
      showNavigation: true,
      signedIn: false,
      id: ''
    }
  },
  computed: {
    profileUrl: function() {
      return 'app/' + this.id
    }
  },
  created: function() {
    firebase.auth().onAuthStateChanged(() => {
      this.signedIn = firebase.auth().currentUser
      this.id = firebase.auth().currentUser.uid
    })
  },
  watch: {
        $route: {
            immediate: true,
            handler(to) {
                document.title = to.meta.title || 'Some Default Title';
                this.showNavigation = to.name != "PublicProfile";
            }
        },
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

button {
  padding: 5px;
}
</style>
